export class TilesetConfig {
  id!: string;
  name!: string;
  canApplyStyle: boolean;
  maxDistance: number;
  url!: string| undefined;

  constructor(id: string, name: string, canApplyStyle: boolean, maxDistance: number, url: string | undefined) {
    this.id = id;
    this.name = name;
    this.canApplyStyle = canApplyStyle;
    this.maxDistance = maxDistance;
    this.url = url;
  }
}
